import api from "@/shared/services/apiClient";

export interface IssueTypeRow {
  code: string;
  descr: { en?: string; ja?: string };
  active: boolean;
  sort_order: number;
  business_unit: string;
}

export const issueTypeService = {
  getAll: async (): Promise<IssueTypeRow[]> => {
    const res = await api.get("/issue-type/list");
    return res.data;
  },

  create: async (data: Omit<IssueTypeRow, "business_unit">) => {
    const res = await api.post("/issue-type/create", data);
    return res.data;
  },

  update: async (code: string, data: Omit<IssueTypeRow, "code" | "business_unit">) => {
    const res = await api.put(`/issue-type/update/${code}`, data);
    return res.data;
  },

  delete: async (code: string) => {
    const res = await api.delete(`/issue-type/delete/${code}`);
    return res.data;
  },
};
